import type { ReactNode } from 'react';
import { Header } from '@/components/Header';
import { DittoThemeApplicator } from '@/components/DittoThemeApplicator';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <DittoThemeApplicator />
      <Header />
      <main className="pb-16">{children}</main>
      <footer className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        <a
          href="https://marlowe.shakespeare.wtf"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
        >
          Vibed with Marlowe
        </a>
        {' · '}
        VidStr — video on Nostr (NIP-71)
      </footer>
    </div>
  );
}
